import { Component } from 'react'
import PropTypes from 'prop-types'
import $ from 'jquery'

import Icon from '../Icons'

class InformationPopup extends Component {
  constructor(props) {
    super(props)
    this.handleClose = this.handleClose.bind(this)
    this.clickHandler = this.clickHandler.bind(this)
    this.handleEscape = this.handleEscape.bind(this)
  }

  componentDidMount() {
    window.addEventListener('click', this.clickHandler)
    window.addEventListener('keydown', this.handleEscape)
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.clickHandler)
    window.removeEventListener('keydown', this.handleEscape)
  }

  handleEscape(e) {
    e = e || window.event
    if (e.keyCode === 27) {
      this.handleClose()
    }
  }

  clickHandler(e) {
    const className = $(e.target).attr('class')
    if (className && className.trim() === 'modal') {
      this.handleClose()
    }
  }

  handleClose() {
    this.props.cancelCallback()
  }

  render() {
    const { isOpen, className, text, header, footer } = this.props
    return (
      <div className={`modal modal--information ${isOpen ? 'is-active' : ''} ${className || ''}`}>
        <div className="modal-background" />
        <div className="modal-content">
          <div className="box">
            <header className="modal__header">
              <span>{header || 'Additional information'}</span>
              <div className="close-button" onClick={this.handleClose}>
                <Icon icon="cross" />
              </div>
            </header>
            <div className="modal__inner">
              <div className="modal__body">
                <div>{text}</div>
              </div>
            </div>
            <footer className="modal__footer">{footer || null}</footer>
          </div>
        </div>
      </div>
    )
  }
}

InformationPopup.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  cancelCallback: PropTypes.func,
  className: PropTypes.string,
  text: PropTypes.string,
  header: PropTypes.string,
  footer: PropTypes.string,
}

export default InformationPopup
